import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CampaignSearchItem {
  uuid: string;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class CampaignRestService {
  private readonly http = inject(HttpClient);

  search(query: string, size = 20): Observable<CampaignSearchItem[]> {
    const params = new HttpParams()
      .set('search', query)
      .set('size', String(size))
      .set('sortBy', 'name')
      .set('sortDirection', 'asc');
    return this.http
      .get<{ content: CampaignSearchItem[] }>('/api/core/campaign/all', { params })
      .pipe(map(r => r.content ?? []));
  }
}
